import { toCamelCaseObj } from '@utils';
import { APIResponse } from '../types/api';
import { CamelCasedObject } from '../types/camelCaseObject';
import {
  CreateCyclePayload,
  Cycle,
  CycleData,
  CycleResponse,
  SquareOff,
  SquareOffResponse,
} from '../types/cycles';
import { CycleEndpoints, intradayPrivateFetcher } from './fetchers';

export async function getCycles(
  params: Record<string, string | number>
): Promise<CamelCasedObject<Cycle>[]> {
  try {
    const response = await intradayPrivateFetcher.get<APIResponse<CycleData>>(
      CycleEndpoints.cycles,
      {
        params,
      }
    );

    return response?.data?.data.cycles.map((x) => toCamelCaseObj(x));
  } catch (e: any) {
    throw e?.response?.data;
  }
}

export async function getCycle(cycleId: number) {
  try {
    const res = await intradayPrivateFetcher.get<APIResponse<CycleResponse>>(
      `${CycleEndpoints.cycles}/${cycleId}/`
    );
    return toCamelCaseObj(res?.data?.data.cycle);
  } catch (error: any) {
    throw error?.response?.data;
  }
}

export async function createCycle(args0: CreateCyclePayload) {
  try {
    const response = await intradayPrivateFetcher.post<
      APIResponse<CycleResponse>
    >(CycleEndpoints.createCycles, args0);

    return response?.data?.data.cycle;
  } catch (e: any) {
    throw e?.response?.data;
  }
}

export async function repairCycle(orderIds: number[]) {
  try {
    const response = await intradayPrivateFetcher.post<APIResponse<any>>(
      CycleEndpoints.repairCycle,
      { order_ids: orderIds }
    );
    return response?.data;
  } catch (e: any) {
    throw e?.response?.data;
  }
}

export async function squareOffCycle(data: SquareOff) {
  try {
    const response = await intradayPrivateFetcher.post<
      APIResponse<SquareOffResponse>
    >(CycleEndpoints.createSquareOff, data);
    return response?.data?.data;
  } catch (e: any) {
    throw e?.response?.data;
  }
}
